import React from 'react';
import consultant from './../../../assets/img/brand/pzu/consultant.png';
import mobile from './../../../assets/img/brand/pzu/mobile.png';
import screen from './../../../assets/img/brand/pzu/screen.png';
import person from './../../../assets/img/brand/pzu/person.png';
import mail from './../../../assets/img/brand/pzu/mail.png';
import write from './../../../assets/img/brand/pzu/write.png';
import notes from './../../../assets/img/brand/pzu/notes.png';
import info from './../../../assets/img/brand/pzu/info.png';
import bone from './../../../assets/img/brand/pzu/bone.png';

const ZasadyUmawiania = () => {
  return (
    <React.Fragment>
      <h3 className="page-header firstColor">Opieka medyczna</h3>

      <div className="text-white p-2 sixthColor iconFromLeft infoIcon mt-4 mb-4">
        <h5 className="firstColor">
          <b>Jak umówić się na wizytę lekarską lub badanie?</b>
        </h5>
      </div>

      <div className="secondColor">
        <p>
          Na wizyty lekarskie <b>nie są wymagane</b> skierowania. Na badania
          laboratoryjne, diagnostyczne oraz zabiegi wymagane jest skierowanie.
          Do Twojej dyspozycji oddajemy:
        </p>

        <b>3 całodobowe infolinie czynne 7 dni w tygodniu:</b>
        <br />
        <br />
        <div className="container">
          <div className="row">
            <div className="col-sm-1 d-flex align-items-center">
              <img src={consultant} alt="consultant" />
            </div>
            <div className="col-sm">
              22 505 15 48; 799 698 698; 801 405 905
              <br />
              <small>
                (opłata zgodna z taryfą operatora. Wybierając numer 801 405 905
                może być naliczona taryfa premium.)
              </small>
            </div>
          </div>
        </div>
        <br />
        <ul>
          <li>
            Konsultant pomoże umówić wizytę i udzieli niezbędnych informacji. Po
            zakończeniu rozmowy otrzymasz SMS potwierdzający termin wizyty.
          </li>
          <li>Dzień przed wizytą dostaniesz SMS przypominający.</li>
          <li>Na wizytę zabierz ze sobą dokument potwierdzający tożsamość.</li>
        </ul>
        <br />
        <b>Portal Pacjenta i aplikacja mobilna</b>
        <br />

        <div className="container">
          <div className="row mt-3">
            <div className="col-sm-1">
              <img src={screen} alt="screen" />
            </div>
            <div className="col-sm-5">
              mojePZU.pl
              <br />
              <small>(po wcześniejszym założeniu konta)</small>
            </div>

            <div className="col-sm-1">
              <img src={mobile} alt="mobile" />
            </div>
            <div className="col-sm-5">
              mojePZU.pl mobile
              <br />
              <small>(do pobrania z App Store i Google Play)</small>
            </div>
          </div>
        </div>

        <div className="container mt-4 p-0">
          <div className="row">
            <div className="col">
              <b>Bezpośrednie umawianie w placówce:</b>
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-sm-1 d-flex align-items-center justify-content-end">
              <img src={person} alt="person" />
            </div>
            <div className="col-sm-11">
              Masz również możliwość <b>bezpośredniego umówienia</b> się w
              placówkach własnych PZU Zdrowie oraz w <b>wybranych</b> placówkach
              partnerskich dostępnych na stronie:{' '}
              <a
                href="https://zdrowie.pzu.pl/listaplacowek"
                target="_blank"
                rel="noopener noreferrer">
                zdrowie.pzu.pl/listaplacowek
              </a>
              .
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col">
              <b>Adres e-mail, do umawiania badań w języku angielskim:</b>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-sm-1 d-flex align-items-center justify-content-end">
              <img src={mail} alt="mail" />
            </div>
            <div className="col-sm-11">
              Jeśli nie posługujesz się biegle językiem polskim, na wizytę lub
              badania możesz umówić się w języku angielskim, wysyłając wiadomość
              na:{' '}
              <b>
                <a href="mailto:zamow_wizyte@pzu.pl">zamow_wizyte@pzu.pl</a>
              </b>{' '}
              lub{' '}
              <b>
                <a href="mailto:visit@pzu.pl">visit@pzu.pl</a>
              </b>
              . Do wiadomości możesz załączyć skierowania. Nasz konsultant
              skontaktuje się z Tobą.
            </div>
          </div>
        </div>
        <br />
        <b className="firstColor mt-4">
          Nie możesz przyjść na wizytę lub badanie - odwołaj ją
        </b>
        <ul className="okCircle">
          <li className="mt-2">odpowiadając NIE na SMS-a przypominającego</li>
          <li className="mt-2">dzwoniąc na infolinię</li>
          <li className="mt-2">klikając odwołaj wizytę w mojePZU</li>
        </ul>
        <br />
        <div className="p-2 sixthColor mt-4 mb-4">
          <h5 className="firstColor ml-4">
            <b>Gwarantowane terminy realizacji wizyt *</b>
          </h5>
        </div>
        <ul className="mt-4 ok">
          <li>Internista 2 dni robocze</li>
          <li>Lekarz rodzinny 2 dni robocze</li>
          <li>Pediatra 2 dni robocze</li>
          <li>Specjaliści 5 dni roboczych</li>
        </ul>
        <p>
          * Wizyty lekarskie realizowane są zgodnie ze standardami dostępności.
          W przypadku <b>wskazania preferencji</b> dotyczących placówki, lekarza
          lub terminu/godziny konsultacji standardy dostępności{' '}
          <b>nie obowiązują</b>. Termin wizyty ustalany jest indywidualnie
          zgodnie z dostępnością świadczenia.
        </p>

        <div className="container">
          <div className="row">
            <div className="col-sm-1 d-flex align-items-center">
              <img src={consultant} alt="consultant" />
            </div>{' '}
            <br />
            <br />
            <div className="col-sm">
              <b>Hot Line - 22 735 39 58</b>
              <br />
              Całodobowa infolinia medyczna, dostępna 7 dni w tygodniu, również
              w święta i dni ustawowo wolne od pracy, gdzie można otrzymać
              pielęgniarską telekonsultację medyczną.
            </div>
          </div>
        </div>
        {/* <br />
        <h3 className="firstColor mt-4">
          <b>Chirurgia jednego dnia (dostępna w zakresie Optimum)</b>
        </h3>
        <div className="container">
          <div className="row mt-4">
            <div className="col-sm-1">
              <img src={bone} alt="bone" />
            </div>
            <div className="col-sm-11">
              Możesz skorzystać ze Świadczenia - Chirurgia jednego dnia,{' '}
              <b>
                po upływie 3 miesięcy od dnia przystąpienia do ubezpieczenia
              </b>
              . Usługi mogą być wykonywane zgodnie z zakresem ubezpieczenia, na
              podstawie skierowania od lekarza. Usługi możesz zarezerwować na
              infolinii PZU Zdrowie pod numerem (22) 735 39 55, od pon. - pt. w
              godzinach 8:00 - 20:00.
              <br />
              <br />
              Usługę uzyskasz w placówce, którą wskaże Ci konsultant infolinii.
              <br />
              <br />
              Szczegółowe warunki usługi, zakres świadczeń oraz cennik
              refundacyjny stanowią załącznik do Umowy nr 13 „Warunki udzielania
              świadczenia - Chirurgia jednego dnia".
            </div>
          </div>
        </div> */}

        {/* <h3 className="firstColor mt-4">
          <b>Medycyna pracy</b>
        </h3> */}
        {/* <div className="container">
          <div className="row mt-4">
            <div className="col-sm-1 d-flex align-items-center text-center">
              <img src={info} alt="info" />
            </div>
            <div className="col-sm-11 sixthColor pt-2 pb-2">
              <h5 className="firstColor">
                <b>Jak umówić się na badanie?</b>
              </h5>
            </div>
          </div>

          <div className="row mt-4">
            <div className="col-sm-1 d-flex align-items-center text-center">
              <img src={write} alt="write" />
            </div>
            <div className="col-sm-11">
              Pracodawca wystawi skierowanie na badanie medycyny pracy i
              przekaże je bezpośrednio do nas.
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-sm-1 d-flex align-items-center">
              <img src={consultant} alt="consultant" />
            </div>
            <div className="col-sm-11">
              Konsultant infolinii skontaktuje się z Tobą i przekaże informację
              o umówionym terminie badania.
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-sm-1 d-flex align-items-center">
              <img src={notes} alt="notes" />
            </div>
            <div className="col-sm-11">
              Po badaniach otrzymasz od lekarza medycyny pracy dwa
              zaświadczenia. Jedno przekazujesz swojemu pracodawcy, a drugie
              zachowujesz dla siebie.
            </div>
          </div>
        </div> */}
      </div>
    </React.Fragment>
  );
};

export default ZasadyUmawiania;
